import styled from '@emotion/styled'
import * as v from '../../../../variables/styled'

export const Cont = styled.div((props)=>({
  flex:1,
  display:'flex',
  flexDirection:'column',

  '.ui.disabled.input':{
    opacity:1
  },
  '.ui.simple.dimmer':{
    backgroundColor:'transparent !important'
  }
}))

export const FiledRowContent = styled.div(()=>({
  // flex: 1,
  minWidth: '12rem',
  marginLeft:'0.5rem',

  '.field-label': {
    fontSize: '1rem',
    fontWeight: 'bold',
    marginBottom: 5
  },

  '.error': {
    color: `${v.textError}`
  },

  '.warning': {
    color: 'orange'
  },

  '.field-input': {
    width: '100%'
  }

}))

export const PurchaseGroupMenuContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '10px',
  flexWrap: 'wrap',

  '.cardMenu': {
    width: '200px', 
    height: '200px',
    margin: '0px 10px 10px 0px',
  }
})

export const BottomActionsContainer = styled.div({
  display: 'flex',
  flexDirection: 'column-reverse',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%', 
  margin: '10px 0px',

  '.cancelBtn': {
    display: 'flex',
    marginTop: '5px',
  },

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'row',

    '.cancelBtn': {
      marginTop: 'unset',
    },
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'row',

    '.cancelBtn': {
      marginTop: 'unset',
    },
  },
})
